module.exports = __webpack_public_path__ + "static/img/icon_Subscription.cba97a57.svg";